import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "ulysses/api";
import "ko-sortable";

"use strict";
$.extend(uly.actions, {
    addfactfield: function(ev, $elt, ui) {
        var model = ui.model;
        model.fact_fields.push({ "field":ko.observable(""), "aggregation":ko.observable("count"), "description":ko.observable("") });
    },
    removefactfield: function(ev, $elt, ui) {
        var data = ui.context.$parent.fact_fields;
        var idx = data.indexOf(ui.model);
        data.splice(idx, 1);
    },
    adddimension: function(ev, $elt, ui) {
        var model = ui.model;
        model.dimensions.push({ "field":ko.observable(""), "description":ko.observable(""), "solr_filter_override":ko.observable("") });
    },
    removedimension: function(ev, $elt, ui) {
        var data = ui.context.$parent.dimensions;
        var idx = data.indexOf(ui.model);
        data.splice(idx, 1);
    },
    adddsfilter: function(ev, $elt, ui) {
        var model = ui.model;
        model.filters.push({"expression":ko.observable(""), "solr_filter":ko.observable("")});
    },
    removedsfilter: function(ev, $elt, ui) {
        var data = ui.context.$parent.filters;
        var idx = data.indexOf(ui.model);
        data.splice(idx, 1);
    }
});

ko.bindingHandlers.datasetsummary = {
    init: function(elt, va, allbindings, model, context) {
        var model = { "summary": ko.observableArray([]), "trigger": ko.observable(0) };
        $(elt).data("summary", model);
        var child = context.createChildContext(model);
        ko.applyBindingsToDescendants(child, elt);
        var interval = setInterval(function() { model.trigger(model.trigger()+1); }, 60000);
        ko.utils.domNodeDisposal.addDisposeCallback(elt, function() {
            clearInterval(interval);
        });
        return { controlsDescendantBindings: true };
        
    },
    update: function(elt, va, allbindings, model, context) {
        var summary = $(elt).data("summary");
        var trigger = ko.unwrap(summary.trigger);
        uly.api.start().follow("uly:app").follow("uly:summary").done(function(data) {
            summary.summary(data.summary);
        });
    }
};
